'use client';

import { usePathname } from 'next/navigation';
import { ProfessionalsNotFound } from '@/content/error/professionals/ProfessionalsNotFound';
import { CustomerNotFound } from '@/content/error/customer/CustomerNotFound';
import LayoutWrapper from '@/components/layout/LayoutWrapper';

export default function NotFound() {
  const pathname = usePathname();

  // Check if the current path starts with /professionals
  const isProfessionalsRoute = pathname.startsWith('/professionals');

  return (
    <LayoutWrapper fullHeight={false}>
      {isProfessionalsRoute ? <ProfessionalsNotFound /> : <CustomerNotFound />}
    </LayoutWrapper>
  );
}
